module.exports = __webpack_public_path__ + "media/images/no-image-1c6baa44.png";